import React, { Component } from 'react';
import ErrorState from '@atlassian/jira-common-components-error-state';
import { FormattedMessage } from '@atlassian/jira-intl';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import errorImageUrl from './assets/oncall-error.svg';
import messages from './messages';
import { DescriptionLine } from './styled';

type Props = {
	isAdmin: boolean;
	instanceUrl: string;
	teamId: string;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class OpsgenieScheduleError extends Component<Props> {
	onGotoOpsgenieButtonClicked = () => {
		const { instanceUrl, teamId } = this.props;
		const url = `${instanceUrl || ''}/teams/dashboard/${teamId}`;
		window.open(url, '_blank');
	};

	renderDescription() {
		const { isAdmin } = this.props;

		return (
			<div>
				<DescriptionLine>
					<FormattedMessage {...messages.errorLine1} />
				</DescriptionLine>
				{isAdmin ? (
					<DescriptionLine data-test-id="opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-admin">
						<FormattedMessage
							{...messages.errorAdmin}
							values={{
								link: (
									<a href=" https://support.atlassian.com/contact/#" target="_blank">
										<FormattedMessage {...messages.contactSupport} />
									</a>
								),
							}}
						/>
					</DescriptionLine>
				) : (
					<DescriptionLine data-test-id="opsgenie-schedule.components.opsgenie-schedule-component.schedule-error.error-non-admin">
						<FormattedMessage {...messages.errorNonAdmin} />
					</DescriptionLine>
				)}
			</div>
		);
	}

	render() {
		const { formatMessage } = this.props.intl;

		return (
			<ErrorState
				header={formatMessage(messages.somethingWrong)}
				// The ErrorState component is a wrapper around Atlaskit EmptyState
				// Whilst the description prop in EmptyState supports ReactNode however
				// the flow typing for this prop is string
				// @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
				description={this.renderDescription()}
				errorImage={errorImageUrl}
				onRetry={this.onGotoOpsgenieButtonClicked}
				retryMessage={messages.action}
			/>
		);
	}
}

export default injectIntl(OpsgenieScheduleError);
